"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var page_visibility_api_1 = require("./page-visibility-api");
var WebOSLifecycle = (function (_super) {
    __extends(WebOSLifecycle, _super);
    function WebOSLifecycle(window) {
        var _this = _super.call(this) || this;
        _this.resumingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        _this.suspendingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        var document = window.document;
        var _a = page_visibility_api_1.detectPageVisibilityApi(document), hiddenAttribute = _a.hiddenAttribute, visibilityChangeEvent = _a.visibilityChangeEvent;
        document.addEventListener(visibilityChangeEvent, function () {
            if (document[hiddenAttribute]) {
                _this.suspendingObserver.notifyObservers({});
            }
            else {
                _this.resumingObserver.notifyObservers({});
            }
        });
        return _this;
    }
    WebOSLifecycle.prototype.onResuming = function (handler) {
        this.resumingObserver.registerObserver(handler, this);
        return true;
    };
    WebOSLifecycle.prototype.onSuspending = function (handler) {
        this.suspendingObserver.registerObserver(handler, this);
        return true;
    };
    return WebOSLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.WebOSLifecycle = WebOSLifecycle;
